// assets
import { ReactComponent as Course} from '../assets/navigation-icons/course.svg';
import FeedIcon from '@mui/icons-material/Feed';
import DashboardIcon from '@mui/icons-material/WidgetsRounded';

const LargeDashboardIcon = (props) => (
    <DashboardIcon
        {...props}
        sx={{
            fontSize: '23px !important'
        }}
    />
);


// icons
const icons = {
    Course,
    FeedIcon,
    DashboardIcon: LargeDashboardIcon
};
// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const userItems = {
    id: 'userItems',
    type: 'group',
    title: 'User',
    divider: false,
    children: [
        {
            id: 'dashboard1',
            title: 'Dashboard',
            type: 'item',
            url: '/',
            icon: icons.DashboardIcon,
        },
        {
            id: 'feed1',
            title: 'News feed',
            type: 'item',
            url: '/feed',
            icon: icons.FeedIcon,
        },
    ]
};

export default userItems;
